import React from 'react';
import { ReactComponent as Logo } from '../../assets/Logo.svg';
import styles from './Navbar.module.css';

export const Navbar = () => {
    return (
        <nav className={styles.navbar}>
            <Logo />
        </nav>
    );
}; 